import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import axios from "axios";

import { createBrowserHistory } from "history";

// layouts

import Auth from "layouts/Auth.js";

// views without layouts
class Main extends Component {
  constructor(props) {
    super(props);

    //--- if reload page set Authorization header ----
    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
  }

  render() {
    return (
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/auth`} component={Auth} />
        <Route path={`${process.env.PUBLIC_URL}/`} exact component={Auth} />
        {/* add redirect for first page */}
        <Redirect from="*" to={`${process.env.PUBLIC_URL}/`} />
      </Switch>
    );
  }
}
export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

export default Main;
